<template>
  <div>
    <Datepicker class="datepicker" v-model="date" />
    <Timepicker class="timepicker" v-model="time" :minuteInterval="minuteInterval" />
  </div>
</template>

<script lang="ts">
import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator'
import Datepicker from '@/components/parts/inputItem/DateInput.vue'
import Timepicker from '@/components/parts/inputItem/TimeInput.vue'
import moment, { Moment } from 'moment'

@Component({
  components: { Datepicker, Timepicker },
})
export default class DatetimeInput extends Vue {
  @Prop() value!: Moment

  @Prop() minuteInterval?: number

  private get date() {
    return this.value
  }

  private set date(date) {
    this.$emit('input', date)
  }

  private get time() {
    return this.value
  }

  private set time(time) {
    if (this.date !== null && time !== null) {
      time.set({ year: this.date.year(), month: this.date.month(), date: this.date.date() })
    }
    this.$emit('input', time)
  }
}
</script>

<style scoped>
.datepicker {
  display:inline-block;
  vertical-align: middle;
}

.timepicker {
  margin-left: 1em;
  display: inline;
  vertical-align: middle;
}

</style>
